import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, mergeMap, catchError} from 'rxjs/operators';
import {combineLatest, of} from 'rxjs';
import {ApiService} from '../../../core/http/api.service';
import {
  GetPropertyNotesResponseModel, GetPropertyUserNotesResponseModel, GetSellerNotesResponseModel
} from '../../../shared/models/properties/properties.models';
import {LoadPropertyNotesActionParams} from '../../models/property.model';
import { PropertyNotesActions } from '../../actions/property/property-notes.actions';

@Injectable()
export class PropertyNotesEffects {

   loadPropertyNotes$ = createEffect(() => this.actions$
    .pipe(
      ofType(PropertyNotesActions.loadPropertyNotes),
      mergeMap(
        (data: LoadPropertyNotesActionParams) => combineLatest([
          this.api.Properties.getPropertyNotes(data.propertyId, data.params),
          this.api.Users.getSellerNotes(data.userId, data.params),
          this.api.Properties.getPropertyUserNotes(data.propertyId, data.params)
        ])
          .pipe(
            map((response: [GetPropertyNotesResponseModel, GetSellerNotesResponseModel, GetPropertyUserNotesResponseModel]) => {
              return PropertyNotesActions.loadPropertyNotesSuccess( {
                data: {
                  propertyNotes: response[0].data,
                  sellerNotes: response[1].data.listings,
                  propertyUserNotes: response[2].data
                }
              });
            }),
            catchError(error => of(PropertyNotesActions.loadPropertyNotesFailure(error)))
          )
      )
    ));

  constructor(
    private actions$: Actions,
    private api: ApiService
  ) {}
}
